import { PRACTICE_CHANNEL } from '../../constants/chat';

export const getReadOnlyChannelData = ({ socialChannel, contextChannel }) => {
  const channel = contextChannel || socialChannel;

  const {
    type,
    blocked,
    archived,
    practiceExists,
    practiceProviders,
    hasPatientPractice,
  } = {
    ...channel,
  };

  const isPracticeChannel = type === PRACTICE_CHANNEL;

  const isNotExistingPractice = isPracticeChannel && !practiceExists;
  const isEmptyPractice = isPracticeChannel && !practiceProviders;
  const isNotInPractice = isPracticeChannel && !hasPatientPractice;

  const isReadOnly =
    isNotExistingPractice || isEmptyPractice || archived || isNotInPractice;

  let textId = 'errors.common';
  if (isEmptyPractice) {
    textId = 'messages.titles.practiceEmpty';
  }
  if (isNotExistingPractice) {
    textId = 'messages.titles.practiceRemoved';
  }
  if (archived) {
    textId = 'messages.titles.archivedChat';
  }
  if (isNotInPractice) {
    textId = 'messages.titles.hasPractice';
  }

  return { isReadOnly, blocked, textId };
};



// WEBPACK FOOTER //
// ./src/utils/messaging/readOnlyChat.js